import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";
interface OtherUserProfileState {
  otherUserProfile: {
    id: number;
    userId: number;
    shortId: string;
    employeeId: number;
    userName: string;
    designation: string;
    userType: string;
    image: string;
    department: string;
    userEmail: string;
  };
  otherUsersCertificates: [];
}

const initialState: OtherUserProfileState = {
  otherUserProfile: {
    id: 0,
    userId: 0,
    shortId: "",
    employeeId: 0,
    userName: "",
    designation: "",
    userType: "",
    image: "",
    department: "",
    userEmail: "",
  },
  otherUsersCertificates: [],
};

const otherUserProfileSlice = createSlice({
  name: "otherUserProfile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(otherUserProfileInfo.fulfilled, (state, action) => {
        state.otherUserProfile = action.payload;
      })
      .addCase(getOtherUsersAllCertificates.fulfilled, (state, action) => {
        state.otherUsersCertificates = action.payload;
      });
  },
});

export const otherUserProfileInfo = createAsyncThunk(
  "otherUser/otherUserInfo",
  async (userShortId: string = "") => {
    const response = await axiosInstance.get(`api/user/userInfo/${userShortId}`);
    return response.data;
  }
);

export const getOtherUsersAllCertificates = createAsyncThunk(
  "getOtherUsersAllCertificates/",
  async (userShortId: string = "") => {
    const response = await axiosInstance.get(
      `api/events/getAllCertificates/${userShortId}`
    );

    return response.data;
  }
);

export default otherUserProfileSlice.reducer;
